import { useSearch } from '@tanstack/react-router';

export function useIsFilterApplied() {
	const { year, causes } = useSearch({ strict: false });
	return year != null || (causes && causes.length > 0);
}
